import ContactFormPro from "@/components/feature/ContactFormPro";

export default function ContactSection() {
  return <ContactFormPro variant="contact-page" formId="contact-form" />;
}